import { EditableText, defineBlock } from "eddev/blocks"
import { Button } from "@components/atoms/Button"
import { IDPBranchDropdown } from "@components/atoms/IDPBranchDropdown"
import { useIsMobile } from "@hooks/useViewportDerived"
import { twMerge } from "tailwind-merge"

export const meta: BlockMeta = {
  title: "Inline CTA",
  category: "common",
  icon: "star-filled",
  keywords: ["cta"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/inline-cta", (props) => {
  const isMobile = useIsMobile()

  return (
    <div className="mt-5 mb-7 relative z-[5]">
      <div className="grid-auto gap-6">
        <div className={twMerge(props.width ? "col-span-12" : "col-span-12 md:col-span-8 md:col-start-3")}>
          <div
            className={
              "flex flex-col gap-8 rounded-md bg-light-grey items-center w-full pt-8 pr-5 pb-5 pl-5 md:flex-row md:justify-between md:gap-4 md:p-5 [&_.button]:grow [&_.button]:whitespace-nowrap [&_.button]:w-full [&_.button]:box-border [&_.button]:min-h-[calc(24px+var(--spacing-3)+var(--spacing-3))] " +
              "md:[&_.button]:grow-0 md:[&_.button]:w-auto"
            }
          >
            <EditableText
              as="h4"
              className="!type-title-xs !text-center !m-0 md:!type-title-s md:!text-left"
              placeholder="Enter text..."
              store="text"
            />

            <div className="flex flex-col gap-3 w-full md:flex-row md:justify-between md:items-center md:w-auto md:gap-4">
              {props.useBranchFinderWidget && !isMobile ? (
                <IDPBranchDropdown medium />
              ) : (
                <>
                  {props.link2?.url && !isMobile && (
                    <Button
                      color="white"
                      size="medium"
                      href={props.link2.url}
                      target={props.link2?.target ? "_blank" : undefined}
                    >
                      {props.link2?.title}
                    </Button>
                  )}
                </>
              )}
              {props.link1?.url && (
                <Button
                  color="yellow"
                  size="medium"
                  icon={props.link1?.target ? "ARROW_UP_RIGHT" : "ARROW_RIGHT"}
                  iconStyle="right"
                  href={props.link1.url}
                  target={props.link1?.target ? "_blank" : undefined}
                >
                  {props.link1?.title}
                </Button>
              )}

              {props.useBranchFinderWidget && isMobile ? (
                <IDPBranchDropdown medium />
              ) : (
                <>
                  {props.link2?.url && isMobile && (
                    <Button
                      color="white"
                      size="medium"
                      href={props.link2.url}
                      target={props.link2?.target ? "_blank" : undefined}
                    >
                      {props.link2?.title}
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
